import Single from './Templates/Single'
import Edit from './Templates/Edit'
/**
 *  Variable que contiene el template el cual se va a rederizar en función de donde se llame a la plantilla
 */
export const templates = {
    'single': Single,
    'edit': Edit
}
